module.exports = __webpack_public_path__ + "img/sample_09_big.89227cdd.gif";